export const arrayWithNEmptyItems = (amount) => {
  let arr = [];
  for (let i = 0; i < amount; i++) {
    arr.push({});
  }
  return arr;
};
